import React from "react";
import { OperationType } from "../../../enums/operation-type.enum";
import { Product } from "../../../store/slices/order/types";
import { AiFillCloseCircle } from "react-icons/ai";
import { CurrencySign, formatAmount } from "../../../utils/helper";
import { operationLabels } from "../../../data/utils";
import { ProductType } from "../../../enums/product-type.enum";
import { getItemPromoPrice } from "../../../utils/helper";
import { useAppSelector } from "../../../store";

type SelectedProductListProp = {
  productsByOperation: {
    operationType: OperationType;
    items: Array<Product>;
  };
  onRemoveSelectedProducts: (productId: string) => void;
};
const SelectedProductList: React.FC<SelectedProductListProp> = ({
  productsByOperation,
  onRemoveSelectedProducts,
}) => {
  const { promoCodeData } = useAppSelector(
    (state) => state.organisationReducer
  );
  return (
    <div className="mb-6">
      <h1 className="my-2 font-semibold text-[0.875rem]">
        {operationLabels.find(
          (label) => label.name === productsByOperation.operationType
        )?.label || ""}
      </h1>

      {productsByOperation.items.map((item) => (
        <div key={item._id} className="mb-4">
          <div className="flex justify-between bg-[#FFFFFF] px-3 py-4 rounded text-[#0C4654] relative mb-2 items-center">
            <div className="flex w-1/2 items-center">
              <AiFillCloseCircle
                onClick={() => onRemoveSelectedProducts(item._id)}
                size="1rem"
                className="absolute right-1 top-1 md:relative md:right-0 md:top-0 text-gray-400"
              />

              <p className="text-base mx-2">{item?.name}</p>
            </div>

            <p className="mb-1 col-span-7  md:mb-0 md:col-start-9 md:row-start-1  text-base-x md:col-span-2 break-words">
              {item.productType === ProductType.Vaccination
                ? `${item?.numberOfDosages} ${item?.numberOfDosages <= 1 ? "Dose" : "Doses"}`
                : "1 Quantity"}
            </p>
            {getItemPromoPrice(item, promoCodeData)?.discount > 0 && (
              <p className="mb-1 col-span-7  md:mb-0 md:col-start-9 md:row-start-1  text-base-x md:col-span-2 break-words">
                Discount: {getItemPromoPrice(item, promoCodeData)?.discount}
              </p>
            )}
            <p className=" md:col-start-11 block md:col-span-2 md:row-start-1  text-base-x break-words">
              {CurrencySign}
              {formatAmount(
                getItemPromoPrice(item, promoCodeData)?.priceAfterDiscount
              )}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectedProductList;
